import React from "react";
import PropTypes from "prop-types";
import {
  TextField,
  FormGroup,
  FormControlLabel,
  List,
  ListItem,
  FormLabel,
  Grid,
  Checkbox,
  withStyles
} from "@material-ui/core";

import HoraireInformationsStyle from "./HoraireInformationsStyle";

import { WORK_DAYS } from "../../../../const";

const HoraireInformations = props => {
  const { values, handleChange, handleBlur, classes } = props;

  return (
    <div>
      <h5>Informations de l'horaire</h5>

      <List>
        {WORK_DAYS.map(day => (
          <ListItem key={day}>
            <Grid container spacing={24}>
              <Grid item xs={6} sm={2}>
                <FormGroup>
                  <FormLabel className={classes.dayLabel}>{day}</FormLabel>
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={`days[${day}][disable]`}
                        onChange={handleChange}
                        checked={values.days[day]["disable"]}
                        value="Fermé"
                      />
                    }
                    label="Fermé"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <TextField
                    type="Time"
                    variant="outlined"
                    disabled={values.days[day]["disable"]}
                    label="Heure d'arrivé"
                    name={`days[${day}][horaireDebutDto]`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.days[day]["horaireDebutDto"]}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <TextField
                    type="Time"
                    variant="outlined"
                    disabled={values.days[day]["disable"]}
                    label="Heure de départ"
                    name={`days[${day}][horaireFinDto]`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.days[day]["horaireFinDto"]}
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

HoraireInformations.propTypes = {
  values: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func
};

export default withStyles(HoraireInformationsStyle)(HoraireInformations);
